import { useEffect, useState } from "react";
import { Insight } from "../types/insight";
import { fetchTopInsights } from "../api/blog";
import { Loader } from "./ui/loader";

const DashboardInsights = () => {

  const [insights, setInsights] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      //setIsLoading(true);
      try {
        const data = await fetchTopInsights();
        setInsights(data);
      } finally {
        //setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="bg-white">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        { insights.length > 0 && ( <div className="grid gap-2 md:grid-cols-2 w-full">
          {/* First Card */}
          <div onClick={() => window.location.href = `/insights/${insights[0].slug}`} className="relative aspect-square w-full flex items-center justify-center overflow-hidden cursor-pointer group">
            <img
              src={insights[0]?.title?.titleImage?.url}
              alt=""
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
            />
            
            {/* Overlay */}
            <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
            <div className="relative p-8 h-[700px]  place-content-center flex flex-col me-auto">
              <div>
                <p className="text-white text-sm font-medium mb-4 tracking-wider">{insights[0]?.title?.insightCategory}</p>
                <h3 className="text-3xl font-medium text-white mb-4 leading-tight">
                  {insights[0]?.title?.title}
                </h3>
                <p className="text-white text-sm mb-6 max-w-[85%]">
                  {insights[0]?.title?.titleDescription}
                </p>
                <button className="flex self-start bg-transparent text-white py-2 text-[14.4px] font-bold duration-300">
                  EXPLORE <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className='ml-[8px] mt-[5.4px] transforms transition-transform duration-300 group-hover:translate-x-2'>
                    <path d="M10.9687 6.28361C11.2593 5.99072 11.2557 5.51586 10.9605 5.22298L6.15076 0.450152C5.8556 0.157267 5.38073 0.157267 5.09009 0.450152C4.79946 0.743037 4.80312 1.2179 5.09827 1.51078L9.37364 5.75329L5.16371 9.99581C4.87308 10.2887 4.87674 10.7636 5.17189 11.0564C5.46705 11.3493 5.94192 11.3493 6.23255 11.0564L10.9687 6.28361ZM0.572754 5.7533L0.578538 6.50327L10.4401 6.50327L10.4343 5.75329L10.4285 5.00332L0.56697 5.00332L0.572754 5.7533Z" fill="white"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          {/* Second Card */}
          <div onClick={() => window.location.href = `/insights/${insights[1].slug}`} className="relative aspect-square w-full flex items-center justify-center overflow-hidden cursor-pointer group">
            <img
              src={insights[1]?.title?.titleImage?.url}
              alt=""
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-black opacity-40 z-0"></div>

            {/* Content */}
            <div className="relative p-8 h-[700px]  place-content-center flex flex-col me-auto">
              <div>
                <p className="text-white text-sm font-medium mb-4 tracking-wider">{insights[1]?.title?.insightCategory}</p>
                <h3 className="text-3xl font-bold text-white mb-4 leading-tight">
                  {insights[1]?.title?.title}
                </h3>
                <p className="text-white text-sm mb-6 max-w-[85%]">
                  {insights[1]?.title?.titleDescription}
                </p>
                <button className="flex self-start bg-transparent text-white py-2 text-[14.4px] font-bold duration-300">
                  EXPLORE <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className='ml-[8px] mt-[5.4px] transforms transition-transform duration-300 group-hover:translate-x-2'>
                    <path d="M10.9687 6.28361C11.2593 5.99072 11.2557 5.51586 10.9605 5.22298L6.15076 0.450152C5.8556 0.157267 5.38073 0.157267 5.09009 0.450152C4.79946 0.743037 4.80312 1.2179 5.09827 1.51078L9.37364 5.75329L5.16371 9.99581C4.87308 10.2887 4.87674 10.7636 5.17189 11.0564C5.46705 11.3493 5.94192 11.3493 6.23255 11.0564L10.9687 6.28361ZM0.572754 5.7533L0.578538 6.50327L10.4401 6.50327L10.4343 5.75329L10.4285 5.00332L0.56697 5.00332L0.572754 5.7533Z" fill="white"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

        </div>)}
      </div>
    </section>
  );
};

export default DashboardInsights;